import { Reveal } from "@/components/landing/Reveal";
import { TiltCard } from "@/components/landing/TiltCard";
import { scrollToId } from "@/lib/site";

const SERVICES = [
  {
    img: "/images/store/comforter_pink.webp", fallback: "/images/store/comforter_pink.jpg",
    title: "Comforters & Heavy Bedding",
    desc: "Sanitized, fluffed & Fall Special priced — $19.99 each when you clean 2+",
  },
  {
    img: "/images/google/g7.webp", fallback: "/images/google/g7.jpg",
    title: "Dry Cleaning & Pressing",
    desc: "Suits, dresses & shirts — crisp every time",
  },
  {
    img: "/images/towels_stack.webp", fallback: "/images/towels_stack.jpg",
    title: "Wash & Fold",
    desc: "By the bag, folded drawer-ready",
  },
  {
    img: "/images/store/bridal_box.webp", fallback: "/images/store/bridal_box.jpg",
    title: "Wedding Gown Preservation",
    desc: "Steamed, preserved & boxed by specialists",
  },
  {
    img: "/images/store/leather.webp", fallback: "/images/store/leather.jpg",
    title: "Leather & Suede Care",
    desc: "Specialist cleaning for jackets, bags & more",
  },
  {
    img: "/images/school_uniforms.webp", fallback: "/images/school_uniforms.png",
    title: "School & Sports Uniforms",
    desc: "Game-day and classroom ready, on schedule",
  },
];

const Card = ({ img, fallback, title, desc }) => (
  <TiltCard>
    <button
      onClick={() => scrollToId("book")}
      data-testid={`service-card-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
      className="group relative block h-64 w-full overflow-hidden rounded-3xl text-left shadow-sm transition-shadow hover:shadow-2xl hover:shadow-brand-blue/20"
    >
      <img
        src={img}
        onError={fallback ? (e) => (e.currentTarget.src = fallback) : undefined}
        alt={title}
        loading="lazy"
        decoding="async"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/90 via-brand-navy/25 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 p-6">
        <h3 className="font-display text-lg font-bold text-white sm:text-xl">{title}</h3>
        <p className="mt-1 text-sm text-slate-300">{desc}</p>
      </div>
    </button>
  </TiltCard>
);

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-slate-50 py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <Reveal className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue sm:text-sm">What we clean</p>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-brand-navy sm:text-3xl lg:text-4xl">
            Everything in your closet. <span className="text-outline-navy block font-extrabold">And your bedroom.</span>
          </h2>
        </div>
        <p className="max-w-sm text-base text-slate-600">
          Every order includes free pickup &amp; delivery across the East Valley.
        </p>
      </Reveal>

      <div data-testid="services-grid" className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08}>
            <Card {...s} />
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-5">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-sky-100 to-brand-blue-light p-8 sm:p-10">
          <img
            src="/images/bubbles_3d.png"
            alt=""
            aria-hidden
            loading="lazy"
            onError={(e) => (e.currentTarget.style.display = "none")}
            className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 object-contain opacity-90"
          />
          <h3 className="max-w-md font-display text-xl font-bold text-brand-navy sm:text-2xl">
            Hypoallergenic &amp; fabric-safe, always
          </h3>
          <p className="mt-2 max-w-md text-base text-slate-600">
            Gentle, solvent-free sanitization that evicts dust mites and protects the pieces you
            love — plus leather care and wedding dress preservation handled by specialists.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
